import {
  DURATION_FILTER_VALUE_SEPARATOR,
  RANGE_FILTER_SEPARATOR,
} from '@aibees/elephant/constants/filters';
import { toNumber } from '@aibees/shared/utils';
import { LimitType, TimeType } from './types';

export function buildDraft(
  currentValue: string[][],
  limit: LimitType,
  time: TimeType,
  value: string
) {
  const draft = currentValue;
  draft[limit][time] = value;

  return draft
    .map((x) => {
      return x.join(DURATION_FILTER_VALUE_SEPARATOR);
    })
    .join(RANGE_FILTER_SEPARATOR);
}

export function validateDurationValue(
  value: string,
  limit: LimitType,
  time: TimeType
) {
  if ((toNumber(value) ?? 0) < 0) return false;
  if (time === TimeType.MONTH && (toNumber(value) ?? 0) > 12) return false;
  return !(time === TimeType.YEAR && (toNumber(value) ?? 0) > 100);
}
